var exports = {
  "a": "branchName__-YcWms",
};

module.exports = exports;
